import { Card } from 'react-bootstrap';

const TitleCard = ({
  title,
  subTitle,
  cardWidth = '100%',
  cardHeight = '100%',
  headerFontSize = '1.8rem',
  children,
  ...props
}) => {
  const cardStyle = {
    width: `${cardWidth}`,
    height: `${cardHeight}`,
    textAlign: 'center',
    margin: 'auto',
  };

  const cardHeaderStyle = {
    fontSize: `${headerFontSize}`,
    backgroundColor: 'transparent',
  };

  return (
    <Card className={`${props.cName}-card`} style={cardStyle}>
      <Card.Header style={cardHeaderStyle}>
        {title}
        {subTitle && <Card.Subtitle className="fw-light my-1">{subTitle}</Card.Subtitle>}
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  );
};

export default TitleCard;
